export type LoginPayload = {
  emailHash: string;
  passwordHash: string;
  email: string;
  isRelogin?: boolean;
};

export type LoginResponse = {
  message: string;
  firebaseProjectId: string;
  patientUUID: string;
  firebasePatientId: string;
  isVerified: boolean;
  isBlocked: boolean;
  loginRetryNumber: number;
  timebetweenLastAttempt: number;
  accessToken: string;
};

export type ResendLoginCodePayload = {
  emailHash: string;
  email: string;
};

export type ResendLoginCodeResponse = {
  loginRetryNumber: number;
  isBlocked: boolean;
  timebetweenLastAttempt: number;
};

export type GetFirebasePayload = { projectId: string; qrCodeUUID: string };

export type GetFirebaseResponse = {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  storageBucket: string;
  iOSAppId: string;
  androidAppId: string;
};

export type MainIPServiceResponse = {
  ip: string;
  country: { iso_code: string };
};

export type AlternativeIPServiceResponse = {
  ipAddress: string;
  countryCode: string;
};

export type GenerateCertificatePayload = {
  patientUuid: string;
  csr: string;
};

export type GenerateCertificateResponse = {
  certificate: string;
};

export type GetFirebaseDataForQRCodePayload = {
  projectId: string;
  qrCodeUUID: string;
};

export type CreateAccountGloballyParams = {
  email: string;
  password: string;
  patientSourceUUID?: string;
  sourceProjectId: string;
};

export type GetPatientDataFromInvitationQRCodeParams = {
  patientSourceUUID: string;
  siteId: string;
  instanceUrl: string;
};

export enum APIErrors {
  RegLetterScanningForbidden = 'PATIENT_NOT_ALLOWED_TO_SCAN_REGISTERATION_LETTER',
}

export type Verify2FACodePayload = {
  emailHash: string;
  pinCode: string;
};

export type Verify2FACodeResponse = {
  firebaseProjectId: string;
  firebasePatientId: string;
  isVerified: boolean;
  patientUUID: string;
  loginRetryNumber?: number;
  isBlocked?: boolean;
  timebetweenLastAttempt?: number;
  accessToken: string;
};

export type VerifyResetRequest = {
  emailHash: string;
  pinCode: string;
};

export type VerifyResetResponse = {
  message: string;
  accessToken: string;
};

export type RegisterPayload = {
  emailHash: string;
  signature: string;
  firebaseProjectId: string;
  patientUUID?: string;
  firebasePatientId?: string;
  secretQuestionId: number;
  passwordHash: string;
  secretQuestionAnswerHash: string;
};

export type RegisterResponse = {
  accessToken: string;
};
